export enum Role {
  Admin = 1,
  Company = 2,
  User = 3,
  SubAdmin = 4,
  AdminUserForCompany = 5
}
